<template>
    <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="box no-display">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Leaving Certificate </strong>
          <v-icon @click="onload" title="Reload list" dark color="yellow"
            >mdi-reload</v-icon
          >
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center">
        <v-col cols="12" sm="4" md="4" class="mt-3">
          <v-combobox
            class="no-display"
            v-model="registration_no"
            @change="checkHistory"
            :loading="comp_load"
            rounded
            :items="stud_list"
            label="Select Student"
            item-text="name"
            outlined
            dense
            prepend-icon="mdi-account-child-circle"
          ></v-combobox>
        </v-col>
      </v-row>
      <div v-if="registration_no != null">
        <template>
          <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Account History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-data-table
                  :headers="headers_1"
                  :items="ay_record"
                  class="elevation-1 mytable"
                  dense
                >
                  <template v-slot:item.status="{ item }">
                    <v-chip :color="getColor(item.status)" dark>
                      {{ item.status }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels class="expapanel no-display" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Academic History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <!-- table content -->

                <v-data-table
                  :headers="headers_2"
                  :items="ay_record_div"
                  dense
                  class="elevation-1 mytable"
                >
                </v-data-table>
                <!-- table end -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>

        <!-- radio button -->
        <v-row justify="center" dense class="no-display">
          <v-radio-group
            v-model="fetch_gen_toggle"
            mandatory
            row
            class="radiobtn"
          >
            <v-radio label="Fetch LC" value="FETCH"></v-radio>
            <v-radio label="Generate LC" value="GENERATE"></v-radio>
          </v-radio-group>
        </v-row>
        <!-- radio button end -->
        <v-row justify="center" v-if="ay_record.length != 0">
          <div class="fees no-display">
            <span v-if="account_status" style="color: #4caf50"
              >Fees Clear
            </span>
            <span v-else style="color: #f44336">Fees Pending</span>
          </div>
        </v-row>
      </div>
    </v-card>
    <div v-if="registration_no != null">
      <!-- generate lc code -->
      <template v-if="fetch_gen_toggle == 'GENERATE'">
        <!-- Date starts -->
        <v-row justify="center" class="mt-3">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="last_date_of_school"
                @blur="date = parseDate(last_date_of_school)"
                v-on="on"
                hint="Last Date of Leaving"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>

          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="gen_date"
                @blur="date = parseDate(gen_date)"
                v-on="on"
                hint="Generation Date"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date2"
              no-title
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu4"
            v-model="menu4"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                dense
                v-model="application_date"
                @blur="date = parseDate(application_date)"
                v-on="on"
                hint="Date Of Application"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_of_application"
              no-title
              @input="menu4 = false"
              @change="setToText()"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu3"
            v-model="menu3"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                dense
                v-model="issue_date"
                @blur="date = parseDate(issue_date)"
                v-on="on"
                hint="Date Of Issue"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              label="Issue Date"
              v-model="date_of_issue"
              no-title
              @input="menu3 = false"
              @change="setToText2()"
            ></v-date-picker>
          </v-menu>
        </v-row>
        <!-- Date ends -->
        <v-row justify="center" class="mt-3">
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="progress"
              rounded
              :items="dvt_prog"
              label="Select Progress"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="conduct"
              rounded
              :items="dvt_conduct"
              label="Select Conduct"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="remark"
              rounded
              :items="dvt_remark"
              label="Select Remark"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="reason"
              rounded
              :items="dvt_reason"
              label="Select Reason"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-3">
          <v-checkbox
            color="#0f2027"
            v-model="mark_inactive"
            label="Do You Want To Mark Student Inactive After Generating LC.?"
          ></v-checkbox>
        </v-row>
        <v-row justify="center">
          <v-btn @click="genLC" :disabled="!condition">Generate LC</v-btn>
        </v-row>
      </template>
      <!-- generate lc code end -->
      <template v-if="fetch_gen_toggle == 'FETCH'">
        <v-btn class="button no-display" @click="fetchLC">Fetch LC</v-btn>
        <br />
      </template>
        <div id="document1" class="printdiv cbse" v-if="lc_data != null">
        <div class="header">
          <div
          >
            <div style="background-color: rgb(248, 246, 226)">
              <v-row style="display: flex; height: 180px">
                <!-- <v-col cols="3" class="inside-header header-row">
                  <div>
                    <center>
                      <img
                        :src="org_basic_data.school_logo"
                        alt="school_logo"
                        height="120px"
                        width="170px"
                      />
                    </center>
                  </div>
                  <center
                    class="tdata2"
                    style="text-transform: uppercase; color: rgb(9, 9, 87)"
                  >
                    {{ org_basic_data.school_name }}
                  </center>
                </v-col>
                <v-col cols="6" sm="6" md="6" class="inside-header header-row">
                  <div style="text-align: center">
                    <p>{{ org_basic_data.trust_name }}</p>
                    <h1 class="header-style">
                      Sanjivani <span class="span-first-letter">A</span>cademy
                    </h1>                    
                    <p>{{ org_basic_data.address }} Pin - {{org_basic_data.pin}}</p>
                    <p>Phone: {{ org_basic_data.phone }}</p>
                    <p>Email:{{ org_basic_data.email }},</p>
                    <p>Website: {{ org_basic_data.website }}</p>
                  </div>
                </v-col>
                <v-col cols="3" class="align-center tdata2 header-row">
                  <span
                    >CBSE Affiliation No. : {{ org_basic_data.cbsc_no }}</span
                  ><br />
                  <span>School Code No. : 30529</span
                  ><br />
                  <span>U-DISE No. : {{ lc_data.udise_no }}</span>
                </v-col> -->
              </v-row>
              <hr style="border: 1px solid black" />
            </div>
            <v-col
              cols="12"
              md="12"
              sm="12"
              style="padding: 0px; font-family: 'Times New Roman', Times, serif"
            >
              <v-row dense class="last-row">
                <v-col cols="auto">
                  <span class="tdata2"
                    >L.C.No: {{ lc_data.certificate_no }}</span
                  >
                  <br />
                </v-col>
                <v-col cols="auto">
                  <span class="tdata2 text-right"
                    >GR. No. {{ lc_data.gr_number }}</span
                  >
                </v-col>
              </v-row>
            </v-col>

            <center>
              <h2 class="heading">LEAVING CERTIFICATE</h2>
            </center>
          </div>          
        </div>
        <div class="lcdata">
          <span
            ><center>
              (No Changes in any entry is to be made except by the authority
              issuing the certificate)
            </center>
          </span>
          <br />
          <!-- lc table content  -->
          <div class="content">
            <table class="page">
              <tbody><tr>
                  <td>PEN ID</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.pen_no }}</td>
                </tr>
                <tr>
                  <td>APAAR ID</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.apaar_id }}</td>
                </tr>
                <tr>
                  <td>Name of the pupil in full</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.fullname }}</td>
                </tr>
                <tr>
                  <td>Father's Full Name</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.father_full_name }}</td>
                </tr>
                <tr>
                  <td>Mother's Name</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.mother_first_name }}</td>
                </tr>
                <tr>
                  <td>Religion, Caste & Sub Caste</td>
                  <td>:</td>
                  <td class="tdata2">
                    {{ lc_data.religion }} - {{ lc_data.caste }}- {{ lc_data.subcaste }}
                  </td>
                </tr>
                <tr>
                  <td>Nationality</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.nationality }}</td>
                </tr>
                <tr>
                  <td>Place of Birth</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.birth_place }}</td>
                </tr>
                <tr>
                  <td>Date of Birth in figure & words</td>
                  <td>:</td>
                  <td class="tdata2">
                    {{ lc_data.dob_fig }} ({{ lc_data.dob_words }})
                  </td>
                </tr>
                <tr>
                  <td>Last School Attended</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.last_school }}</td>
                </tr>
                <tr>
                  <td>Date of Admission in & class</td>
                  <td>:</td>
                  <td class="tdata2">
                    {{ lc_data.doa }} ({{ lc_data.admittedstandard }})
                  </td>
                </tr>
                <tr>
                  <td>School Annual Examination with result</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.result_status }}</td>
                </tr>
                <tr>
                  <td>Progress in Studies</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.progress }}</td>
                </tr>
                <tr>
                  <td>Conduct in School</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.conduct }}</td>
                </tr>
                <tr>
                  <td>Date of Application for Certificate</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.date_of_application }}</td>
                </tr>
                <tr>
                  <td>Date of issue of certificate</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.date_of_issue }}</td>
                </tr>
                <tr>
                  <td>Standard in which pupil was studying</td>
                  <td>:</td>
                  <td class="tdata2">
                    {{ lc_data.standard }}
                  </td>
                </tr>
                <tr>
                  <td>Reason of Leaving School</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.reason }}</td>
                </tr>
                <tr>
                  <td>Remark</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.remark }}</td>
                </tr>
              </tbody>
            </table>
            <!-- lc table end -->
            <hr style="border: 1px dashed black; width: 90%; margin: auto;" />            
            <div style="margin-left: 5%; margin-right: 5%">
              <span class="tdata2 ml-2 font-size"
                >Certified that above Mentioned information is True According to
                the School General Register. </span
              >
              
                <v-row dense class="place-and-date-row pt-1">
                  <v-col class="pl-5" cols="6">
                    <span class="tdata2">Place: Khirdi Ganesh, Kopargaon</span>
                    <br />
                  </v-col>
                  <v-col cols="6" align="right">
                    <span class="tdata2"
                      >Date : {{ lc_data.gen_date }}</span
                    >
                  </v-col>
                </v-row>
             
            </div>
            <br /> <br>           
              <v-row class="mt-10 tdata2 font-size">
                <v-col cols="4" align="center"><span>Prepared By</span> </v-col>
                <v-col cols="4" align="center">
                  <span>Class Teacher</span>
                </v-col>
                <v-col cols="4" align="center">
                  <span>Principal</span>
                </v-col>
              </v-row>            
          </div>
        </div>
      </div>
    </div>
    <div class="no-display" v-if="lc_data != null">
      <div style="text-align: center">
        ----------------------------------Modify------------------------------------
      </div>
      <br />

      <v-row justify="center" class="mt-3">
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Progress"
            v-model.trim="lc_data.progress"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Conduct"
            v-model.trim="lc_data.conduct"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Remark"
            v-model.trim="lc_data.remark"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Reason"
            v-model.trim="lc_data.reason"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="student_result_status">
        <v-col cols="12" sm="3" md="3">
          <v-select
            label="Result Status"
            v-model.trim="lc_data.result_status"
            :items="result_status_list"
            item-text="name"
            item-value="name"
          ></v-select>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn class="mb-2 button" color="warning" @click="savegenLC()" small
          >Save</v-btn
        >
      </v-row>
      <hr />
      <v-row class="no-display">
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Birth in words"
            v-model.trim="lc_data.dob_words"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Last School"
            v-model.trim="lc_data.last_school"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Standard"
            v-model.trim="lc_data.standard"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Since when..."
            v-model.trim="lc_data.standard_since_when"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Caste"
            v-model.trim="lc_data.caste"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Religion"
            v-model.trim="lc_data.religion"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-btn @click="proceed" class="info">Proceed to print</v-btn>
      </v-row>
    </div> 
    </div>   
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
      data() {
    return {
      mark_inactive: false,
      headers_1: [
        { text: "Academic Year", value: "ay" },
        { text: "Paid", value: "paid" },
        { text: "Balance", value: "balance" },
        { text: "Status", value: "status" },
      ],
      headers_2: [
        { text: "Academic Year", value: "ay" },
        { text: "Roll No", value: "rollno" },
        { text: "Div", value: "div" },
        { text: "Std", value: "std" },
        { text: "Total", value: "total" },
        { text: "Present ", value: "present" },
      ],

      comp_load: false,
      fetch_loader: false,
      overlay: false,
      snackbar: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      registration_no: null,
      stud_list: [],
      ay_record: [],
      ay_record_div: [],
      account_status: false,
      dvt_prog: [],
      progress: null,
      dvt_conduct: [],
      conduct: null,
      dvt_reason: [],
      reason: null,
      result_status:null,
      result_status_list:[
        { name:"Pass", id: 1 },
        { name:"Fail", id: 2 },
      ],
      student_result_status: false,
      dvt_remark: [],
      remark: null,
      fetch_gen_toggle: "FETCH",
      board_toggle: "SSC",
      //////date
      last_date_of_school: "",
      gen_date: "",
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date_of_application: new Date().toISOString().substr(0, 10),
      date_of_issue: new Date().toISOString().substr(0, 10),
      application_date: "",
      issue_date: "",
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      nowDate: new Date().toISOString().slice(0, 10),
      ///
      lc_data: null,
      org_basic_data: null,
      condition: false,
      org_id: null,
    };
  },
  watch: {
    date(val) {
      this.last_date_of_school = this.formatDate(this.date);
    },
    date2(val) {
      this.gen_date = this.formatDate(this.date2);
    },
    date_of_application(val) {
      this.application_date = this.formatDate(this.date_of_application);
      this.lc_data.date_of_application = this.application_date;
    },
    date_of_issue(val) {
      this.issue_date = this.formatDate(this.date_of_issue);
      this.lc_data.date_of_issue = this.issue_date;
    },
  },
  methods: {
    setToText() {
      this.lc_data.date_of_application = this.application_date;
    },
    setToText2() {
      this.lc_data.date_of_issue = this.issue_date;
    },
    savegenLC() {
      const formData = {
        lid: this.registration_no.lid,
        progress: this.lc_data.progress,
        conduct: this.lc_data.conduct,
        remark: this.lc_data.remark,
        reason: this.lc_data.reason,
        gen_date: this.date_of_generation,
      };
      if (this.student_result_status) {
        formData.result_status = this.lc_data.result_status;
      }
      this.overlay = true;
      axios
        .post("/certificate/genLC", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            // this.lc_data.last_school = this.org_basic_data.school_name;
            this.showSnackbar("green", "Saved Successfully..!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    proceed() {
      localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
      localStorage.setItem(
        "org_basic_data",
        JSON.stringify(this.org_basic_data)
      );
      let routeData = this.$router.resolve({ name: "sak-lc-print" });
      window.open(routeData.href, "_blank");
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    getColor(status) {
      if (status === "pending") return "red";
      if (status === "clear") return "green";
      if (status === "NA") return "gray";
    },

    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },

    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    onload() {
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.all_stud_list;
          } else {
            this.showSnackbar("red", "Something went wrong.");
          }
          this.comp_load = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.comp_load = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    checkHistory() {
      console.log("registration_no:", this.registration_no);
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      if (this.registration_no == null) {
        this.showSnackbar("red", "Please select student");
      }
      this.overlay = true;
      axios
        .post("/certificate/checkHistory", this.registration_no)
        .then((res) => {
          console.log("res", res.data);
          if (res.data.flag == "YES") {
            this.ay_record = res.data.ay_record;
            this.account_status = res.data.account_status;
            this.ay_record_div = res.data.ay_record_div;
            this.dvt_prog = res.data.dvt_prog;
            this.progress = this.dvt_prog[0];
            this.dvt_conduct = res.data.dvt_conduct;
            this.conduct = this.dvt_conduct[0];
            this.dvt_reason = res.data.dvt_reason;
            this.reason = this.dvt_reason[0];
            this.dvt_remark = res.data.dvt_remark;
            this.remark = this.dvt_remark[0];
            this.condition = res.data.condition;
            if (!this.condition)
              this.showSnackbar("red", res.data.condition_msg);
          } else {
            this.showSnackbar("red", res.data.snackbar);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    genLC() {
      if (this.account_status == false) {
        if (
          !confirm(
            "Are You Sure You Want To generate LC as fees is pending...?"
          )
        )
          return;
      }
      if (
        this.progress != null &&
        this.conduct != null &&
        this.last_date_of_school != "" &&
        this.gen_date != "" &&
        this.remark != null &&
        this.reason != null &&
        this.application_date != "" &&
        this.issue_date != ""
      ) {
        const formData = {
          lid: this.registration_no.lid,
          progress: this.progress,
          conduct: this.conduct,
          remark: this.remark,
          reason: this.reason,
          last_date_of_school: this.last_date_of_school,
          gen_date: this.gen_date,
          date_of_application: this.application_date,
          date_of_issue: this.issue_date,
          mark_inactive: this.mark_inactive,
        };
        this.overlay = true;
        axios
          .post("/certificate/genLC", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.org_basic_data = res.data.org_basic_data;
              this.lc_data = res.data.lc_data;
              // this.lc_data.last_school = this.org_basic_data.school_name;
              // if (this.lc_data.caste == null) {
              //   alert("Caste is not enter ..");
              // }
              // this.showSnackbar("green", "User data fetched!!!");
            } else {
              this.showSnackbar("red", res.data.snackbar);
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            this.overlay = false;
          })
          .catch((error) => {
            this.onerror(error);

            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        this.showSnackbar("red", "Please select/enter all data");
      }
    },
    fetchLC() {
      this.overlay = true;
      axios
        .post("/certificate/fetchLC", this.registration_no)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            // this.lc_data.last_school = this.org_basic_data.school_name;
            this.date_of_application = this.formatDate(
              this.lc_data.date_of_application
            );
            this.date_of_issue = this.formatDate(this.lc_data.date_of_issue);
            this.student_result_status = res.data.student_result_status;
            // this.showSnackbar("green", "User data fetched!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    localStorage.setItem("lc_data", null);
    localStorage.setItem("org_basic_data", null);
    localStorage.setItem("last_date_of_school", "");
    this.onload();
    this.last_date_of_school = this.formatDate(this.date);
    this.gen_date = this.formatDate(this.date2);
    this.application_date = this.formatDate(this.date_of_application);
    this.issue_date = this.formatDate(this.date_of_issue);
    this.org_id = localStorage.getItem("EPS-org-id")
  },
};
</script>
<style scoped>
.scroll {
  overflow-x: scroll;
}
.mytable1 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.mytable /deep/ thead th {
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
tr,
td,
th {
  /* border: 1px solid #ccc; */
  text-align: center;
  font-size: small;
}
tr,
tbody {
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
.expapanel {
  width: 93%;
  margin-left: 3%;
}

.panelheader {
  /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
  color: white !important;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #3792c7,
    #60e3eb,
    #a0dfe3
  ); /* Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  font-size: 16px;
  background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
}
.fees span {
  font-size: 23px;
  font-weight: 600;
}
/* lc data css */
.printdiv {
  height: auto;
  margin-left: 15%;
  margin-right: 15%;
  background-color: rgb(248, 248, 241);
  background-position: center;
}
.header {
  margin: 6px;
}
.tdata2 {
  font-weight: bolder;
}
.last-row {
  display: flex;
  justify-content: space-around;
  width: 100%;
  /* margin-bottom: -15px; */
}
.page {
  margin-left: 60px;
  margin-top: 0px;
  border: none !important;
}
.lcdata {
  font-family: "Times New Roman", Times, serif;
}
.content {
  padding-bottom: 10px;
}
.heading {
  letter-spacing: 1px;
  text-decoration: underline;
  font-family: "Times New Roman", Times, serif;
}
.inside-header {
  border-right: 1px solid black;
  height: auto;
}
.header-row {
  padding-top: 15px;
}
.header-style {
  font-family: serif;
  color: rgb(151, 17, 17);
}
.header-style::first-letter {
  font-family: "GregorianFLF", serif;
  color: rgb(151, 17, 17);
}
.header-style .span-first-letter {
  font-family: "GregorianFLF", serif;
  color: rgb(151, 17, 17);
}
.align-center {
  padding-top: 50px;
  font-size: medium;
}
p {
  font-size: medium;
  margin: 0;
  font-weight: 600;
}
h1 {
  color: rgb(235, 61, 61);
}
.page tr,
.page td {
  font-size: large;
  text-align: left;
  border: none !important;
}
/* lc data css end */

/* print lc css */
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  body,
  tr,
  th,
  td {
    font-size: x-large !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  p , .align-center{
      font-size: 17px !important;
  }
  .header-style{
      font-size: 40px !important;
  }
  .printdiv {
    margin: 0;
    padding: 0;
  }
  .cbse{
    margin-left: -15px !important;
    width: 102%;
  }
  .page{
    line-height: 200% !important;
  }
  #document1 {
    position: absolute;
    margin-top: -63px;
    top: 0;
    /* left: 0;
    right: 0; */
    bottom: 0;
  }
  .place-and-date-row, .font-size{
    font-size: 22px !important;
  }
  @page {
    size: A4;
    margin: none;
    padding-top: none;
    size: 11.5in 16.5in;
  }
}
/* print lc css end */
span.stretch {
  display: inline-block;
  -webkit-transform: scale(1.5, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}
.stretch1 {
  display: inline-block;
  -webkit-transform: scale(1.3, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}

h3.stretch2 {
  display: inline-block;
  -webkit-transform: scale(2, 1); /* Safari and Chrome */
  -moz-transform: scale(1.5, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
}
</style>